var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "mb-0", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { staticStyle: { "background-color": "#ffe1ce" } },
            [
              _c("v-col", [
                _c("h1", { staticClass: "text-center main-title" }, [
                  _vm._v(_vm._s(_vm.$t("passValidation.title")))
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-form",
        {
          ref: "checkForm",
          attrs: { "lazy-validation": "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validate.apply(null, arguments)
            }
          },
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.validate($event)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-lg": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-container",
                    { staticClass: "mt-7" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "d-flex justify-center align-center" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "9" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("passValidation.passNumber"),
                                  required: "",
                                  rules: [_vm.rules.required],
                                  maxlength: 50
                                },
                                on: {
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.validate()
                                  }
                                },
                                model: {
                                  value: _vm.number,
                                  callback: function($$v) {
                                    _vm.number = $$v
                                  },
                                  expression: "number"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "d-flex justify-center align-center" },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "9" } },
                            [
                              _c("vue-recaptcha", {
                                ref: "recaptcha",
                                attrs: {
                                  size: "invisible",
                                  loadRecaptchaScript: true,
                                  sitekey: _vm.recaptchaSiteKey
                                },
                                on: {
                                  verify: _vm.onCaptchaVerified,
                                  expired: _vm.onCaptchaExpired
                                }
                              }),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    block: "",
                                    depressed: "",
                                    tile: "",
                                    color: "primary",
                                    loading: _vm.checkingPass,
                                    disabled: _vm.checkingPass
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.validate()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("passValidation.validateButton")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.errNotFound
                        ? _c(
                            "v-row",
                            {
                              staticClass: "d-flex justify-center align-center"
                            },
                            [
                              _c("v-col", { attrs: { cols: "12", sm: "9" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "error--text font-weight-middle"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("passValidation.passNotFound")
                                      )
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  !_vm.errNotFound
                    ? _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "d-flex justify-center align-center"
                            },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "9" } },
                                [
                                  _vm.passValidationInfo.number
                                    ? _c(
                                        "v-container",
                                        { staticClass: "mt-7 mb-4 pb-10" },
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "12"
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "passValidation.passNumber"
                                                        )
                                                      ) + ":"
                                                    )
                                                  ]),
                                                  _c("br"),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "word-break":
                                                          "break-all"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm
                                                              .passValidationInfo
                                                              .number
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" / "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "word-break":
                                                          "break-all"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm
                                                              .passValidationInfo
                                                              .title
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.passValidationInfo.entries,
                                            function(item, index) {
                                              return _c(
                                                "v-row",
                                                { key: index },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "6",
                                                        sm: "8"
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.code ==
                                                              "Parking"
                                                              ? "mdi-car"
                                                              : "mdi-counter"
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.code ==
                                                              "Parking"
                                                              ? _vm.$t(
                                                                  "passValidation.parkingCount"
                                                                )
                                                              : _vm.$t(
                                                                  "passValidation.entriesCount"
                                                                )
                                                          ) +
                                                          " "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "6",
                                                        sm: "4"
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(item.count))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", sm: "8" }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-calendar-start")
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "passValidation.passValidFrom"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", sm: "4" }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(this.validFrom) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", sm: "8" }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-calendar-end")
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "passValidation.passValidTo"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "6", sm: "4" }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(this.validTo) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        { staticClass: "d-flex justify-center align-center" },
                        [
                          _c("v-col", { attrs: { cols: "12", sm: "9" } }, [
                            _c("p", { staticClass: "text-caption" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("passValidation.ticketInfo"))
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "https://www.botanickaliberec.cz/#vstupne",
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "passValidation.ticketInfoAdmission"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _c("p", { staticClass: "text-caption" }, [
                              _vm._v(
                                _vm._s(_vm.$t("passValidation.updateInfo"))
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-overlay",
                { attrs: { value: _vm.checkingPass } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "64", color: "primary" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }